import { cva as r } from "class-variance-authority";
const e = r(
  "",
  {
    variants: {
      variant: {
        default: "flex items-end justify-center w-8 h-8 rounded-sm bg-white border border-solid border-primary-50 text-neutral-90"
      }
    }
  }
);
export {
  e as PaginationEllipsisVariants
};
//# sourceMappingURL=PaginationEllipsisVariants.mjs.map
